<template>
  <div>
    <v-row fluid
           style="background-color: unset"
           v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
           v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
      <v-col cols="12">
        <h3>Kursentwicklung</h3>
        <fin-chart2 :options="chartOptions" v-if="chartOptions"/>
      </v-col>
    </v-row>
    <v-row v-if="!hideNews && !noEscapeLink"
           style="background-color: #FFFFFF"
           v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
           v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
      <v-col>
        <h3>Nachrichten</h3>
        <fin-company-page-news :items="newsArticles" @allNews="$emit('allNews')"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FinCompanyPageNews from '@/components/pages/finCompanyPage/news/index'
import FinChart2 from "@/components/common/Chart2/FinChart2"
import FinChartBuilder from "@/components/common/Chart2/FinChartBuilder"

export default {
  name: 'fin-company-page-overview',
  components: {
    FinChart2,
    FinCompanyPageNews
  },
  props: {
    displayColor: {
      type: String,
      default: '$finColor.primaryDark'
    },
    newsArticles: {
      type: Array
    },
    instrument: {},
    /** if the company page is opened from the onboarding, then no link should allow
     * the user to quit the onboarding pages */
    noEscapeLink: {
      type: Boolean,
      default: false
    },
    realtimeSubscription:{}
  },
  data() {
    return {
      tabModel: 0,
      hideSubTabOverviewFundamentalKeyFigures: process.env.VUE_APP_HIDE_SUBTAB_OVERVIEW_FUNDAMENTALKEYFIGURES === 'true',
      hideSubTabOverviewValuationMetrics: process.env.VUE_APP_HIDE_SUBTAB_OVERVIEW_VALUATIONMETRICS === 'true',
      hideNews: process.env.VUE_APP_HIDE_NEWS_ALL === 'true',
      chartOptions: null
    }
  },
  watch:{
    instrument:{
      immediate:true,
      handler(val){
        this.chartOptions = {
          chart: {
            height: 400,
          },
          rangeSelector: {
            initSelection: 2
          },
          series: [{
            name: val.name,
            data: FinChartBuilder.mapTimeSeriesPoint(val.mainListing ? [...val.mainListing.timeSeries, ...val.timeSeriesRT] : []),
            type: 'area',
          }],
          yAxis: {
            showExtremes: {
              min: true,
              max: true,
            }
          },
          tooltip: {
            valueSuffix: "€",
            pointFormat: this.$vuetify.breakpoint.smAndDown ? '{point.y}' : '{series.name}: {point.y}'
          },
          credits: {
            html:FinChartBuilder.createRealTimeCredits()
          },
          subscriptions: [
            {
              subscription: this.realtimeSubscription,
              trigger({data}, {chart}){
                 const {price: y, timestamp} = data.onCreateRealTimePrice
                 const x = (new Date(timestamp)).getTime()
                 if(chart.series?.length){
                   const {selected} = chart.rangeSelector || {}
                   chart.series[0].addPoint([x, y], false, false)
                   const {min} = chart.xAxis[0].getExtremes()
                   chart.xAxis[0].setExtremes(min, x, true, true, { trigger: 'addPoint'})
                   chart.rangeSelector.clickButton(selected)
                 }
              }
            }
          ]
        }
      }
    }
  },
  mounted() {
    if (!this.hideSubTabOverviewFundamentalKeyFigures) {
      this.tabs.push({name: 'Fundamentalkennzahlen'})
    }
    if (!this.hideSubTabOverviewValuationMetrics) {
      this.tabs.push({name: 'Bewertungskennzahlen'})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

::v-deep .range-selector-buttons {
  top: 7px;
  position: relative;
}

@media only screen and (max-width: 600px) {
  ::v-deep .dropdown {
    top: -30px;
    position: relative;
  }
}

.v-tab {
  font-size: 14px !important;
}
</style>
